import { render, staticRenderFns } from "./ActiveSource.vue?vue&type=template&id=97c5027c"
import script from "./ActiveSource.vue?vue&type=script&lang=js"
export * from "./ActiveSource.vue?vue&type=script&lang=js"
import style0 from "./ActiveSource.vue?vue&type=style&index=0&id=97c5027c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports